import React, { useEffect } from "react";
import { StyleSheet, View } from "react-native";
import { Color } from "../assets";
import {GlobalScreens} from "../utils/globalConstant";

const RadioButton = ({ isSelected, btnColor }) => {
  return (
    <View
      style={[
        styles.outerCircle,
        {
          borderColor: isSelected ? btnColor : GlobalScreens.SingleOrder.radioBorder,
        },
      ]}
    >
      {isSelected ? (
        <View style={[styles.innerCircle, { backgroundColor: btnColor }]} />
      ) : null}
    </View>
  );
};

export default RadioButton;

const styles = StyleSheet.create({
  outerCircle: {
    height: 16,
    width: 16,
    borderRadius: 8,
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  innerCircle: {
    height: 8,
    width: 8,
    borderRadius: 4,
    backgroundColor: Color.tradexBlue,
  },
});
